import { useState } from 'react';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';
import { Container } from '../components/layout/Primitives';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';

export default function Contact() {
  const [flash, setFlash] = useState(null);

  return (
    <div className="animate-fade-in">
      <section style={{ background: 'hsla(38,25%,90%,0.5)', borderBottom: '1px solid hsl(35,18%,84%)', padding: 'clamp(3rem,8vw,6rem) 1.5rem', textAlign: 'center' }}>
        <p className="font-mono-luxe" style={{ margin: '0 0 1rem', fontSize: '11px', color: '#524D46' }}>
          We&apos;re Here to Help
        </p>
        <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2.75rem,6vw,4.5rem)', lineHeight: 0.95 }}>Contact</h1>
        <p style={{ margin: '1.25rem auto 0', maxWidth: '36rem', opacity: 0.65, paddingInline: '1rem' }}>
          Our client advisors are available to assist with orders, styling, alterations and appointments.
        </p>
      </section>

      <Container style={{ padding: 'clamp(4rem,6vw,6rem) 1.5rem', display: 'grid', gap: 'clamp(3rem,5vw,4rem)' }} className="contact-grid">
        <style>{`@media(min-width:1024px){.contact-grid{grid-template-columns:1fr 1fr!important}}`}</style>

        <div>
          <h2 className="font-display" style={{ margin: '0 0 2rem', fontSize: 'clamp(1.75rem,3vw,2rem)' }}>Get in touch</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
            {[
              { icon: Mail, label: 'Email', value: 'hello@modamai.com' },
              { icon: Phone, label: 'Phone', value: '+45 33 12 00 00' },
              { icon: MapPin, label: 'Flagship', value: 'Bredgade 23, 1260 Copenhagen, Denmark' },
              { icon: Clock, label: 'Hours', value: 'Mon–Sat, 10:00 — 19:00 CET' },
            ].map((c) => (
              <div key={c.label} style={{ display: 'flex', gap: '1rem' }}>
                <div style={{ width: '2.5rem', height: '2.5rem', borderRadius: '50%', background: 'hsl(38,25%,90%)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <c.icon size={18} style={{ color: '#524D46' }} />
                </div>
                <div>
                  <p className="font-mono-luxe" style={{ margin: '0 0 0.25rem', fontSize: '11px', opacity: 0.55 }}>
                    {c.label}
                  </p>
                  <p style={{ margin: 0, fontSize: '0.875rem' }}>{c.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '3rem', paddingTop: '3rem', borderTop: '1px solid hsl(35,18%,84%)' }}>
            <h3 className="font-display" style={{ margin: '0 0 1rem', fontSize: '1.5rem' }}>Frequently Asked</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {[
                ['Shipping', 'Complimentary worldwide shipping on all orders over $250. Express options at checkout.'],
                ['Returns', 'Easy returns within 30 days. Items must be unworn with original tags.'],
                ['Alterations', 'Complimentary minor alterations on tailoring where available.'],
              ].map(([t, b]) => (
                <details key={t} style={{ borderBottom: '1px solid hsl(35,18%,84%)', paddingBottom: '1rem' }}>
                  <summary style={{ cursor: 'pointer', fontSize: '0.875rem', fontWeight: 500, listStyle: 'none', display: 'flex', justifyContent: 'space-between' }}>
                    {t}
                  </summary>
                  <p style={{ margin: '0.75rem 0 0', fontSize: '0.875rem', opacity: 0.65, lineHeight: 1.6 }}>{b}</p>
                </details>
              ))}
            </div>
          </div>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            setFlash({ kind: 'ok', text: "We'll respond within 24 hours." });
            e.currentTarget.reset();
          }}
          style={{ background: 'hsla(38,25%,90%,0.35)', padding: 'clamp(1.75rem,4vw,2.5rem)', display: 'flex', flexDirection: 'column', gap: '1.25rem', alignSelf: 'start' }}
        >
          <h2 className="font-display" style={{ margin: 0, fontSize: 'clamp(1.75rem,3vw,2rem)' }}>Send a message</h2>
          {flash && (
            <p role="status" style={{ margin: 0, fontSize: '0.875rem', color: flash.kind === 'ok' ? '#524D46' : '#a00' }}>
              {flash.text}
            </p>
          )}
          <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: '1fr', }} className="contact-two">
            <style>{`@media(min-width:640px){.contact-two{grid-template-columns:1fr 1fr!important}}`}</style>
            <Input placeholder="First Name" required />
            <Input placeholder="Last Name" required />
          </div>
          <Input type="email" placeholder="Email" required />
          <Input placeholder="Subject" />
          <Textarea placeholder="Your message" rows={6} required />
          <Button type="submit" $variant="luxe" $size="lg" style={{ width: '100%' }}>
            Send Message
          </Button>
        </form>
      </Container>
    </div>
  );
}
